import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { CATEGORIES, COURSES, PATHS, getCourse } from '../data/courses';
import './AllPrograms.css';

const GROUP_ORDER = ['standard', 'mastery', 'robotics'];

const GROUP_INTRO = {
  standard: 'Foundations and core skills, from first code to real projects.',
  mastery: 'Longer, deeper courses for students ready to build advanced projects.',
  robotics: 'Hands-on robotics with a real robot kit delivered home.',
};

const AllPrograms = () => {
  return (
    <section className="rmprog" aria-labelledby="rmprog-title">
      <div className="rmprog-inner">
        {/* Page header */}
        <header className="rmprog-header">
          <span className="rmprog-eyebrow">Our programs</span>
          <h1 id="rmprog-title" className="rmprog-title">
            {COURSES.length} courses, <span>one path for every child</span>
          </h1>
          <p className="rmprog-sub">
            Live 1-to-1 online classes in coding, AI and robotics for ages 6–17. Every course is project-based, and
            each one leads to the next.
          </p>
          <div className="rmprog-legend" aria-label="Package colors">
            {GROUP_ORDER.map((key) => (
              <a key={key} href={`#rmprog-${key}`} className="rmprog-legend-item">
                <span className="rmprog-dot" style={{ background: CATEGORIES[key].color }} aria-hidden="true" />
                {CATEGORIES[key].label}
              </a>
            ))}
          </div>
        </header>

        {/* Learning paths */}
        <div className="rmprog-paths">
          <h2 className="rmprog-h2">Grow step by step</h2>
          <div className="rmprog-paths-grid">
            {PATHS.map((path) => (
              <div key={path.id} className="rmprog-path">
                <h3 className="rmprog-path-title">{path.title}</h3>
                <ol className="rmprog-steps">
                  {path.steps.map((id, i) => {
                    const c = getCourse(id);
                    if (!c) return null;
                    const cat = CATEGORIES[c.category];
                    return (
                      <li key={id} className="rmprog-step">
                        <span className="rmprog-step-num" aria-hidden="true">
                          {i + 1}
                        </span>
                        <div className="rmprog-step-body">
                          <span className="rmprog-step-name">{c.title}</span>
                          <span className="rmprog-step-meta">
                            <span className="rmprog-dot" style={{ background: cat.color }} aria-hidden="true" />
                            {cat.label} · {c.sessions} sessions
                          </span>
                        </div>
                        {i < path.steps.length - 1 && (
                          <FontAwesomeIcon icon={faArrowRight} className="rmprog-step-arrow" aria-hidden="true" />
                        )}
                      </li>
                    );
                  })}
                </ol>
              </div>
            ))}
          </div>
        </div>

        {/* Full catalog, grouped by package */}
        {GROUP_ORDER.map((key) => {
          const cat = CATEGORIES[key];
          const list = COURSES.filter((c) => c.category === key);
          if (!list.length) return null;
          return (
            <div key={key} id={`rmprog-${key}`} className="rmprog-group" style={{ '--rmprog-accent': cat.color, '--rmprog-ink': cat.ink }}>
              <div className="rmprog-group-head">
                <h2 className="rmprog-h2">
                  <span className="rmprog-dot rmprog-dot--lg" aria-hidden="true" />
                  {cat.label} courses
                  <span className="rmprog-count">{list.length}</span>
                </h2>
                <p className="rmprog-group-intro">{GROUP_INTRO[key]}</p>
              </div>

              <div className="rmprog-grid">
                {list.map((c) => (
                  <article key={c.id} className={`rmprog-card ${c.isNew ? 'is-new' : ''}`}>
                    <div className="rmprog-card-top">
                      <h3 className="rmprog-card-title">{c.title}</h3>
                      {c.isNew && <span className="rmprog-new">NEW</span>}
                    </div>
                    <p className="rmprog-card-text">{c.description}</p>
                    <div className="rmprog-card-meta">
                      <span className="rmprog-sessions">
                        <strong>{c.sessions}</strong> sessions
                      </span>
                      <span>Ages {c.age}</span>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          );
        })}

        <a href="#pricing" className="rmprog-to-pricing">
          See the packages for these courses
          <FontAwesomeIcon icon={faArrowDown} />
        </a>
      </div>
    </section>
  );
};

export default AllPrograms;